import React from "react";
import "./Results.css";
import Meaning from "./Meaning";

export default function Result(props) {
  if (props.results) {
    return (
      <div className="Results">
        <section>
          <h2>{props.results.word}</h2>/{props.results.phonetic}/
        </section>
        {props.results?.meanings?.map(function (meaning, index) {
          return (
            <section key={index}>
              <Meaning meaning={meaning} />
            </section>
          );
        })}
      </div>
    );
  } else {
    return null;
  }
}
